import createIcon from '../../createIcon';

/**
 * @component @name Watch
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMTJDMjAgOS40NiAxOC44MSA3LjE5IDE2Ljk2IDUuNzNMMTYgMEg4TDcuMDUgNS43M0M1LjE5IDcuMTkgNCA5LjQ1IDQgMTJDNCAxNC41NSA1LjE5IDE2LjgxIDcuMDUgMTguMjdMOCAyNEgxNkwxNi45NiAxOC4yN0MxOC44MSAxNi44MSAyMCAxNC41NCAyMCAxMlpNNiAxMkM2IDguNjkgOC42OSA2IDEyIDZDMTUuMzEgNiAxOCA4LjY5IDE4IDEyQzE4IDE1LjMxIDE1LjMxIDE4IDEyIDE4QzguNjkgMTggNiAxNS4zMSA2IDEyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Watch = createIcon('Watch', [
  [
    'path',
    {
      d: 'M20 12C20 9.46 18.81 7.19 16.96 5.73L16 0H8L7.05 5.73C5.19 7.19 4 9.45 4 12C4 14.55 5.19 16.81 7.05 18.27L8 24H16L16.96 18.27C18.81 16.81 20 14.54 20 12ZM6 12C6 8.69 8.69 6 12 6C15.31 6 18 8.69 18 12C18 15.31 15.31 18 12 18C8.69 18 6 15.31 6 12Z',
      key: '1uvhjr',
    },
  ],
]);

export default Watch;
